export default __webpack_public_path__ + "static/_PRO-dashboard-mockup 2-96d9ee2e0b7e2aa1c809e312432b16cf.png";